
import { defineComponent, ref, onMounted } from "vue"
import { Actions } from "@/store/enums/StoreEnums"
import { useStore } from "vuex"
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb"
import { ElMessage, ElMessageBox } from "element-plus"
import { CardRarity } from "@/store/modules/CardRarityModule"

export default defineComponent({
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("稀有度列表", ["抽卡系统"])
    })

    const store = useStore()
    const tableData = ref<CardRarity[]>([])

    const formData = ref({
      name: ''
    })

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
    })

    const query = () => {
      store
        .dispatch(Actions.GET_CARD_RARITY_LIST, { ...formData.value, ...page.value })
        .then(() => {
          tableData.value = store.getters.currentCardRarityList
          page.value.totalResult = store.getters.currentCardRarityCount
        })
        .catch(() => {
          ElMessage.error('获取稀有度列表失败')
        })
    }

    query()

    const submitEvent = () => {
      page.value.currentPage = 1
      query()
    }

    const onPageChange = (e: { currentPage: number; pageSize: number }) => {
      page.value.currentPage = e.currentPage
      page.value.pageSize = e.pageSize
      query()
    }

    const onReset = () => {
      formData.value = {
        name: ''
      }
      page.value.currentPage = 1
      query()
    }

    const onDelete = (row: CardRarity) => {
      ElMessageBox.confirm(
        `确定要删除稀有度「${row.name}」吗？`,
        '删除确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          store
            .dispatch(Actions.DELETE_CARD_RARITY, row.id)
            .then((data: { success: boolean; error_msg?: string }) => {
              if (data.success) {
                ElMessage.success('删除成功')
                query()
              } else {
                ElMessage.error(data.error_msg || '删除失败')
              }
            })
            .catch(() => {
              ElMessage.error('删除失败')
            })
        })
        .catch(() => {
          // 取消删除
        })
    }

    return {
      tableData,
      formData,
      submitEvent,
      page,
      onPageChange,
      onReset,
      onDelete
    }
  },
})
